(function(Marionette, Pixlee) {
    _.extend(Marionette.Renderer, {
        render: function(template, data) {
            if (template == false) {
                return;
            }
            var templateFunc;
            if (_.isFunction(template)) {
                // This is to support webpacker that uses ejs-loader.
                // With webpacker we import the template directly as a function, 
                // and pass it to the view
                templateFunc = template;
            } else {
                // This is deprecated
                templateFunc = JST[template];
                if (!templateFunc) {
                    throw 'Template ' + template + ' not found!';
                }
            }
            _.extend(data, Pixlee.viewHelpers);
            return templateFunc(data);
        }
    });
})(Marionette, Pixlee);
